import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnvironmentalSavingsComponent } from './environmental-savings/environmental-savings.component';
import { NewsComponent } from './news/news.component';
import { GlobalEnvironmentalSavingsComponent } from './global-environmental-savings/global-environmental-savings.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ProfileOverviewComponent } from './profile-overview/profile-overview.component';
import { PersonalInfoComponent } from './personal-info/personal-info.component';
import { ChangeProfileImgComponent } from './change-profile-img/change-profile-img.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EmailPreferencesComponent } from './email-preferences/email-preferences.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActionButtonComponent } from './action-button/action-button.component';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { PortletComponent } from './portlet/portlet.component';
import { SharedModule } from '@piqet-angular/shared';
import { DateAgoPipe } from './news/date-ago.pipe';
import { ImageCropperModule } from 'ngx-image-cropper';
import { PaymentTermsAndConditionsComponent } from './payment-terms-and-conditions/payment-terms-and-conditions.component';
import { MouseWheelDirective } from './change-profile-img/mousewheel.directive';
import { SelectOrganizationComponent } from './select-organization/select-organization.component';
import { NewCustomMaterialComponent } from './new-custom-material/new-custom-material.component';
import { LetModule } from '@ngrx/component';
import { CustomCopyComponent } from './custom-copy/custom-copy.component';
import { RouterModule } from '@angular/router';
import { CustomDeleteComponent } from './custom-delete/custom-delete.component';
import { NewCustomConversionComponent } from './new-custom-conversion/new-custom-conversion.component';
import { GridCellLinkComponent } from './grid-cell-link/grid-cell-link.component';
import { MyOrganizationDeleteComponent } from './my-organization-delete/my-organization-delete.component';
import { NewCustomFillingComponent } from './new-custom-filling/new-custom-filling.component';
import { GridCellDropdownComponent } from './grid-cell-dropdown/grid-cell-dropdown.component';
import { AddEditSsoGroupComponent } from './add-edit-sso-group/add-edit-sso-group.component';
import { NewCustomTruckComponent } from './new-custom-truck/new-custom-truck.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NewCustomTransportScenarioComponent } from './new-custom-transport-scenario/new-custom-transport-scenario.component';
import { NewCustomStorageComponent } from './new-custom-storage/new-custom-storage.component';
import { NewWasteScenarioComponent } from './new-waste-scenario/new-waste-scenario.component';
import { NewCustomReuseComponent } from './new-custom-reuse/new-custom-reuse.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NewMyOrganizationManageUserComponent } from './new-my-organization-manage-user/new-my-organization-manage-user.component';
import { NewMyTeamsComponent } from './new-my-teams/new-my-teams.component';
import { NewManageProductGroupsComponent } from './new-manage-product-groups/new-manage-product-groups.component';
import { NewManageProjectWorkflowComponent } from './new-manage-project-workflow/new-manage-project-workflow.component';
import { NewManageScenarioWorkflowComponent } from './new-manage-scenario-workflow/new-manage-scenario-workflow.component';
import { ListOfSuppliersComponent } from './list-of-suppliers/list-of-suppliers.component';
import { EditOrganizationYearEndComponent } from './edit-organization-year-end/edit-organization-year-end.component';
import { EditCustomSpeedosComponent } from './edit-custom-speedos/edit-custom-speedos.component';
import { CustomPackagingMetricsComponent } from './custom-packaging-metrics/custom-packaging-metrics.component';
import { CustomCategoryComponent } from './custom-category/custom-category.component';
import { EditLitterImpactComponent } from './edit-litter-impact/edit-litter-impact.component';
import { GridCellInputComponent } from './grid-cell-input/grid-cell-input.component';
import { NumericCellEditor } from '../../../ui/src/lib/numeri-cell-editor/numeric-cell-editor.component';
import { GridIconComponent } from './grid-icon/grid-icon.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { AdminLoginLogsHistoryComponent } from './admin-login-logs-history/admin-login-logs-history.component';
import { MessageComponent } from './message/message.component';
import { NewAdminOrganizationComponent } from './new-admin-organization/new-admin-organization.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NewOrganizationMembershipComponent } from './new-organization-membership/new-organization-membership.component';
import { NewProcessingConversionComponent } from './new-processing-conversion/new-processing-conversion.component';
import { AddMaterialsComponent } from './add-materials/add-materials.component';
import { AddIngredientsComponent } from './add-ingredients/add-ingredients.component';
import { AddRecycledMaterialComponent } from './add-recycled-material/add-recycled-material.component';
import { NewAreaBasedConversionComponent } from './new-area-based-conversion/new-area-based-conversion.component';
import { NewEnergyAndAncillaryComponent } from './new-energy-and-ancillary/new-energy-and-ancillary.component';
import { NewAdminProcessingTransportComponent } from './new-admin-processing-transport/new-admin-processing-transport.component';
import { NewProcessingCustomConversionComponent } from './new-processing-custom-conversion/new-processing-custom-conversion.component';
import { NewUsersTeamMembershipComponent } from './new-users-team-membership/new-users-team-membership.component';
import { AddTeamTeamMembershipComponent } from './add-team-team-membership/add-team-team-membership.component';
import { ProcessingStorageComponent } from './processing-storage/processing-storage.component';
import { NewProcessingWasteComponent } from './new-processing-waste/new-processing-waste.component';
import { NewRefrigeratedTruckComponent } from './new-refrigerated-truck/new-refrigerated-truck.component';
import { NewProcessingCustomTruckComponent } from './new-processing-custom-truck/new-processing-custom-truck.component';
import { AddEolComponent } from './add-eol/add-eol.component';
import { NewOtherDataMaterialComponent } from './new-other-data-material/new-other-data-material.component';
import { NewCircularEconomyParameterComponent } from './new-circular-economy-parameter/new-circular-economy-parameter.component';
import { NewPalletTypeComponent } from './new-pallet-type/new-pallet-type.component';
import { NewProjectStatusComponent } from './new-project-status/new-project-status.component';
import { NewEquivalancyUnitsComponent } from './new-equivalancy-units/new-equivalancy-units.component';
import { GridEquivalancyImageComponent } from './grid-equivalancy-image/grid-equivalancy-image.component';
import { AddConversionMappingComponent } from './add-conversion-mapping/add-conversion-mapping.component';
import { AddRecycledContentComponent } from './add-recycled-content/add-recycled-content.component';
import { NewCountryIndetifiersComponent } from './new-country-indetifiers/new-country-indetifiers.component';
import { AddProductPackagingRatioComponent } from './add-product-packaging-ratio/add-product-packaging-ratio.component';
import { NewAdminMiscSimulationComponent } from './new-admin-misc-simulation/new-admin-misc-simulation.component';
import { NewViewLogEntriesComponent } from './new-view-log-entries/new-view-log-entries.component';
import { AddCountryComponent } from './add-country/add-country.component';
import { GridMyProjectImageComponent } from './grid-my-project-image/grid-my-project-image.component';
import { NewMyProjectsComponent } from './new-my-projects/new-my-projects.component';
import { AddStateComponent } from './add-state/add-state.component';
import { AddCityComponent } from './add-city/add-city.component';
import { GridNewAddProjectSliderComponent } from './grid-new-add-project-slider/grid-new-add-project-slider.component';
import { AddAdminNewsComponent } from './add-admin-news/add-admin-news.component';
import { NewMyProjectCopyComponent } from './new-my-project-copy/new-my-project-copy.component';
import { GridProjectLinkComponent } from './grid-project-link/grid-project-link.component';
import { AddRoleComponent } from './add-role/add-role.component';
import { GridLinkRolesDetailComponent } from './grid-link-roles-detail/grid-link-roles-detail.component';
import { InvoiceDataModalComponent } from './invoice-data-modal/invoice-data-modal.component';
import { NewAddProjectScenarioComponent } from './new-add-project-scenario/new-add-project-scenario.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { NewProjectMaterialComponent } from './new-project-material/new-project-material.component';
import { NewProjectScenarioRetailComponent } from './new-project-scenario-retail/new-project-scenario-retail.component';
import { NewAddProjectScenarioConsumerComponent } from './new-add-project-scenario-consumer/new-add-project-scenario-consumer.component';
import { NewAddProjectScenarioWholesaleDataComponent } from './new-add-project-scenario-wholesale-data/new-add-project-scenario-wholesale-data.component';
import { NewAddProjectScenarioFillDataComponent } from './new-add-project-scenario-fill-data/new-add-project-scenario-fill-data.component';
import { NewAddProjectScenarioManufacturingComponent } from './new-add-project-scenario-manufacturing/new-add-project-scenario-manufacturing.component';
import { UploadImportComponent } from './upload-import/upload-import.component';
import { CopyProjectScenarioComponent } from './copy-project-scenario/copy-project-scenario.component';
import { CopyReportTemplateComponent } from './copy-report-template/copy-report-template.component';
import { NewProjectMaterialCopyComponent } from './new-project-material-copy/new-project-material-copy.component';
import { NewProjectInlineDropdownComponent } from './new-project-inline-dropdown/new-project-inline-dropdown.component';
import { GridProjectAutocompleteComponent } from './grid-project-autocomplete/grid-project-autocomplete.component';
import { FullDetailReportComponent } from './full-detail-report/full-detail-report.component';
import { LifeCycleImpactChartComponent } from './life-cycle-impact-chart/life-cycle-impact-chart.component';
import { ProjectPalletConfigurationComponent } from './project-pallet-configuration/project-pallet-configuration.component';
import { NewProductProjectComponent } from './new-product-project/new-product-project.component';
import { NewProductIngredientComponent } from './new-product-ingredient/new-product-ingredient.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { DropdownScenarioConfigComponent } from './dropdown-scenario-config/dropdown-scenario-config.component';
import { DropdownReportConfigComponent } from './dropdown-report-config/dropdown-report-config.component';
import { NewEolPreRetailComponent } from './new-eol-pre-retail/new-eol-pre-retail.component';
import { GridCellRendererComponent } from './grid-cell-renderer/grid-cell-renderer.component';
import { OrganiaztionEquivalancyUnitComponent } from './organiaztion-equivalancy-unit/organiaztion-equivalancy-unit.component';
import { PackagingMatricsComponent } from './packaging-matrics/packaging-matrics.component';
import { ReportImpactItemComponent } from './report-impact-item/life-cycle-stage-chart';
import { ReportBarChartComponent } from './report-bar-chart/report-bar-chart.component';
import { ReportDetailContributionChartComponent } from './report-detail-contribution-chart/report-detail-contribution-chart.component';
import { ReportProductDetailComponent } from './report-product-detail/report-product-detail.component';
import { ReportIngredientdatasourceDetailsComponent } from './report-ingredientdatasource-details/report-ingredientdatasource-details.component';
import { ReportCategoriesDefinitionComponent } from './report-categories-definition/report-categories-definition.component';
import { ReportDataSourceEtailsComponent } from './report-data-source-etails/report-data-source-etails.component';
import { ReportBarChartComponentComponent } from './report-bar-chart-component/report-bar-chart-component.component';
import { ReportBarChartIngredientComponent } from './report-bar-chart-ingredient/report-bar-chart-ingredient.component';
import { ReportScenarioDetailComponent } from './report-scenario-detail/report-scenario-detail.component';
import { NgChartsModule } from 'ng2-charts';
import { CompactDetailReportComponent } from './compact-detail-report/compact-detail-report.component';
import { ProductWasteReportComponent } from './product-waste-report/product-waste-report.component';
import { CarbonFootprintReportComponent } from './carbon-footprint-report/carbon-footprint-report.component';
import { ReportSlidesComponent } from './report-slides/report-slides.component';
import { SimpaleDeckReportComponent } from './simpale-deck-report/simpale-deck-report.component';
import { ReportConfigCheckboxComponent } from './report-config-checkbox/report-config-checkbox.component';
import { AddPackagingContentConfigurationComponent } from './add-packaging-content-configuration/add-packaging-content-configuration.component';
import { AddSkuDataComponent } from './add-sku-data/add-sku-data.component';
import { AddProductUseImpactComponent } from './add-product-use-impact/add-product-use-impact.component';
import { GridCellInfoComponent } from './grid-cell-info/grid-cell-info.component';
import { AddProductEolComponent } from './add-product-eol/add-product-eol.component';
import { JoyrideModule } from 'ngx-joyride';
import { NotFoundComponent } from './not-found/not-found.component';
import { SelectNewProjectComponent } from './select-new-project/select-new-project.component';
import { InlineActionButtonComponent } from './inline-action-button/inline-action-button.component';
import { IsoReportComponent } from './iso-report/iso-report.component';
import { InlineTooltipComponent } from './inline-tooltip/inline-tooltip.component';
import { DataQualityAssessmentDropdownComponent } from './data-quality-assessment-dropdown/data-quality-assessment-dropdown.component';
import { CustomProjectReportComponent } from './custom-project-report/custom-project-report.component';
import { AddProductUseComponent } from './add-product-use/add-product-use.component';
import { ReportBugComponent } from './report-bug/report-bug.component';
import { AdminCopyOrganizationComponent } from './admin-copy-organization/admin-copy-organization.component';
import { AdditionalInfoNewsComponent } from './additional-info-news/additional-info-news.component';
import { TableOfContentComponent } from './table-of-content/table-of-content.component';
import { ReportShareComponent } from './report-share/report-share.component';
import { IndicatorSelectModalComponent } from './indicator-select-modal/indicator-select-modal.component';
import { AgGridModule } from 'ag-grid-angular';
import { VerificationButtonRendererComponent } from './verification-button-renderer/verification-button-renderer.component';
import { BookmarkComponent } from './bookmark/bookmark.component';
import { HistoryRendererComponent } from './history-renderer/history-renderer.component';
import { HistoryDetailsComponent } from './history-details/history-details.component';
import { ImportNewProjectMaterialComponent } from './import-new-project-material/import-new-project-material.component';
import { ImportProjectPalletConfigurationComponent } from './import-project-pallet-configuration/import-project-pallet-configuration.component';
import { ExcleTemplateInfoComponent } from './excle-template-info/excle-template-info.component';
import { MaterialCertificateComponent } from './material-certificate/material-certificate.component';
import { NewOrganizationDataMapComponent } from './new-organization-data-map/new-organization-data-map.component';
import { AutomationWorkFlowComponent } from './automation-work-flow/automation-work-flow.component';
import { EmailTemplateEditorComponent } from './email-template-editor/email-template-editor.component';
import { TestAutomationComponent } from './test-automation/test-automation.component';
import { NewAddSubProductComponent } from './new-add-sub-product/new-add-sub-product.component';
import { CopySubProductComponent } from './copy-sub-product/copy-sub-product.component';
import { NavigationButtonComponent } from './navigation-button/navigation-button.component';
import { IncorrectDataNotificationComponent } from './incorrect-data-notification/incorrect-data-notification.component';
import { InvalidEolScenarioComponent } from './invalid-eol-scenario/invalid-eol-scenario.component';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { RadarChartComponent } from './radar-chart/radar-chart.component';
import HighchartsMore from 'highcharts/highcharts-more';
import { ImportIssueResolverComponent } from './import-issue-resolver/import-issue-resolver.component';
import { CommonButtonComponent } from './common-button/common-button.component';
import { MailSenderComponent } from './mail-sender/mail-sender.component';
import { GaugeChartComponent } from './gauge-chart/gauge-chart.component';
import { CommentBoxComponent } from './comment-box/comment-box.component';
import { ImportVersionCommentComponent } from './import-version-comment/import-version-comment.component';
import { CreateSnapshotComponent } from './create-snapshot/create-snapshot.component';
import { SignupUserDetailsComponent } from './signup-user-details/signup-user-details.component';
import { ChartAtGlanceComponent } from './chart-at-glance/chart-at-glance.component';
import { AddMainProductConfigurationComponent } from './add-main-product-configuration/add-main-product-configuration.component';
import { PremiumHeaderComponent } from './premium-header/premium-header.component';

export function highchartsModules() {
  return [HighchartsMore];
}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgOptionHighlightModule,
    ImageCropperModule,
    SharedModule,
    LetModule,
    RouterModule,
    NgxSliderModule,
    AutocompleteLibModule,
    CKEditorModule,
    NgChartsModule,
    JoyrideModule.forChild(),
    AgGridModule,
    HighchartsChartModule,
  ],

  exports: [
    EnvironmentalSavingsComponent,
    NavigationButtonComponent,
    IncorrectDataNotificationComponent,
    NewsComponent,
    GlobalEnvironmentalSavingsComponent,
    IncorrectDataNotificationComponent,
    ProfileOverviewComponent,
    PersonalInfoComponent,
    ChangeProfileImgComponent,
    ActionButtonComponent,
    ChangePasswordComponent,
    EmailPreferencesComponent,
    BreadcrumbsComponent,
    PaymentTermsAndConditionsComponent,
    PortletComponent,
    DateAgoPipe,
    SelectOrganizationComponent,
    MouseWheelDirective,
    NewCustomConversionComponent,
    GridCellDropdownComponent,
    NgbModule,
    UserDetailsComponent,
    FullDetailReportComponent,
    IsoReportComponent,
    CompactDetailReportComponent,
    ProductWasteReportComponent,
    CarbonFootprintReportComponent,
    ReportSlidesComponent,
    SimpaleDeckReportComponent,
    LifeCycleImpactChartComponent,
    PackagingMatricsComponent,
    ReportImpactItemComponent,
    ReportBarChartComponent,
    ReportBarChartIngredientComponent,
    ReportBarChartComponentComponent,
    ReportDetailContributionChartComponent,
    ReportProductDetailComponent,
    ReportScenarioDetailComponent,
    ReportIngredientdatasourceDetailsComponent,
    ReportCategoriesDefinitionComponent,
    ReportDataSourceEtailsComponent,
    CustomProjectReportComponent,
    MaterialCertificateComponent,
    AutomationWorkFlowComponent,
    BarChartComponent,
    CommonButtonComponent,
    RadarChartComponent,
    GaugeChartComponent,
    NewMyOrganizationManageUserComponent,
    CommentBoxComponent,
    ImportVersionCommentComponent,
    CreateSnapshotComponent,
    ChartAtGlanceComponent,
    AddMainProductConfigurationComponent,
    PremiumHeaderComponent,
  ],
  declarations: [
    EnvironmentalSavingsComponent,
    IncorrectDataNotificationComponent,
    NewsComponent,
    MouseWheelDirective,
    GlobalEnvironmentalSavingsComponent,
    ProfileOverviewComponent,
    PersonalInfoComponent,
    ChangeProfileImgComponent,
    ChangePasswordComponent,
    EmailPreferencesComponent,
    BreadcrumbsComponent,
    ActionButtonComponent,
    DateAgoPipe,
    PaymentTermsAndConditionsComponent,
    PortletComponent,
    SelectOrganizationComponent,
    NewCustomMaterialComponent,
    CustomDeleteComponent,
    CustomCopyComponent,
    NewCustomConversionComponent,
    GridCellLinkComponent,
    MyOrganizationDeleteComponent,
    NewCustomFillingComponent,
    GridCellDropdownComponent,
    AddEditSsoGroupComponent,
    NewCustomTruckComponent,
    NewCustomTransportScenarioComponent,
    NewCustomStorageComponent,
    NewWasteScenarioComponent,
    NewCustomReuseComponent,
    NewMyOrganizationManageUserComponent,
    NewMyTeamsComponent,
    NewManageProductGroupsComponent,
    NewManageProjectWorkflowComponent,
    NewManageScenarioWorkflowComponent,
    ListOfSuppliersComponent,
    EditOrganizationYearEndComponent,
    EditCustomSpeedosComponent,
    CustomPackagingMetricsComponent,
    CustomCategoryComponent,
    EditLitterImpactComponent,
    GridCellInputComponent,
    NumericCellEditor,
    GridIconComponent,
    NewAdminOrganizationComponent,
    UserDetailsComponent,
    AdminLoginLogsHistoryComponent,
    MessageComponent,
    NewOrganizationMembershipComponent,
    NewProcessingConversionComponent,
    AddMaterialsComponent,
    AddIngredientsComponent,
    AddRecycledMaterialComponent,
    NewAreaBasedConversionComponent,
    NewEnergyAndAncillaryComponent,
    NewAdminProcessingTransportComponent,
    NewProcessingCustomConversionComponent,
    NewUsersTeamMembershipComponent,
    AddTeamTeamMembershipComponent,
    ProcessingStorageComponent,
    NewProcessingWasteComponent,
    NewRefrigeratedTruckComponent,
    NewProcessingCustomTruckComponent,
    AddEolComponent,
    NewOtherDataMaterialComponent,
    NewOtherDataMaterialComponent,
    NewCircularEconomyParameterComponent,
    NewPalletTypeComponent,
    NewProjectStatusComponent,
    NewEquivalancyUnitsComponent,
    GridEquivalancyImageComponent,
    AddConversionMappingComponent,
    AddRecycledContentComponent,
    NewCountryIndetifiersComponent,
    AddProductPackagingRatioComponent,
    NewAdminMiscSimulationComponent,
    NewViewLogEntriesComponent,
    AddCountryComponent,
    GridMyProjectImageComponent,
    NewMyProjectsComponent,
    AddStateComponent,
    AddCityComponent,
    GridNewAddProjectSliderComponent,
    AddAdminNewsComponent,
    NewMyProjectCopyComponent,
    GridProjectLinkComponent,
    AddRoleComponent,
    GridLinkRolesDetailComponent,
    InvoiceDataModalComponent,
    NewAddProjectScenarioComponent,
    TermsAndConditionsComponent,
    NewProjectMaterialComponent,
    NewProjectScenarioRetailComponent,
    NewAddProjectScenarioConsumerComponent,
    NewAddProjectScenarioWholesaleDataComponent,
    NewAddProjectScenarioFillDataComponent,
    NewAddProjectScenarioManufacturingComponent,
    UploadImportComponent,
    CopyProjectScenarioComponent,
    CopyReportTemplateComponent,
    NewProjectMaterialCopyComponent,
    NewProjectInlineDropdownComponent,
    GridProjectAutocompleteComponent,
    FullDetailReportComponent,
    LifeCycleImpactChartComponent,
    ProjectPalletConfigurationComponent,
    NewProductProjectComponent,
    NewProductIngredientComponent,
    DropdownScenarioConfigComponent,
    DropdownReportConfigComponent,
    NewEolPreRetailComponent,
    GridCellRendererComponent,
    OrganiaztionEquivalancyUnitComponent,
    PackagingMatricsComponent,
    ReportImpactItemComponent,
    ReportBarChartComponent,
    ReportDetailContributionChartComponent,
    ReportProductDetailComponent,
    ReportIngredientdatasourceDetailsComponent,
    ReportCategoriesDefinitionComponent,
    ReportDataSourceEtailsComponent,
    ReportBarChartComponentComponent,
    ReportBarChartIngredientComponent,
    ReportScenarioDetailComponent,
    CompactDetailReportComponent,
    ProductWasteReportComponent,
    CarbonFootprintReportComponent,
    ReportSlidesComponent,
    SimpaleDeckReportComponent,
    ReportConfigCheckboxComponent,
    AddPackagingContentConfigurationComponent,
    AddSkuDataComponent,
    AddProductUseImpactComponent,
    GridCellInfoComponent,
    AddProductEolComponent,
    NotFoundComponent,
    SelectNewProjectComponent,
    InlineActionButtonComponent,
    IsoReportComponent,
    InlineTooltipComponent,
    DataQualityAssessmentDropdownComponent,
    CustomProjectReportComponent,
    AddProductUseComponent,
    ReportBugComponent,
    AdminCopyOrganizationComponent,
    AdditionalInfoNewsComponent,
    TableOfContentComponent,
    ReportShareComponent,
    IndicatorSelectModalComponent,
    VerificationButtonRendererComponent,
    BookmarkComponent,
    HistoryRendererComponent,
    HistoryDetailsComponent,
    ImportNewProjectMaterialComponent,
    ImportProjectPalletConfigurationComponent,
    ExcleTemplateInfoComponent,
    MaterialCertificateComponent,
    NewAddSubProductComponent,
    CopySubProductComponent,
    NewOrganizationDataMapComponent,
    AutomationWorkFlowComponent,
    EmailTemplateEditorComponent,
    TestAutomationComponent,
    NavigationButtonComponent,
    IncorrectDataNotificationComponent,
    InvalidEolScenarioComponent,
    BarChartComponent,
    NavigationButtonComponent,
    RadarChartComponent,
    ImportIssueResolverComponent,
    CommonButtonComponent,
    MailSenderComponent,
    GaugeChartComponent,
    CommentBoxComponent,
    ImportVersionCommentComponent,
    CreateSnapshotComponent,
    SignupUserDetailsComponent,
    ChartAtGlanceComponent,
    AddMainProductConfigurationComponent,
    PremiumHeaderComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: HighchartsChartModule, useFactory: highchartsModules }, // add as factory to your providers
  ],
})
export class UiModule {}
